import { useQuery } from "@tanstack/react-query";
import { GenieProduct, ProductGenieService } from "@/services/marketplace/ProductGenieService";

/** The catalogue products a genie answers for; empty for a genie with no marketplace listing. */
export const useGenieProducts = (agentId: string | null | undefined) =>
  useQuery<GenieProduct[]>({
    queryKey: ["genie-products", agentId],
    queryFn: () => ProductGenieService.listProductsForGenie(agentId!),
    enabled: !!agentId,
    staleTime: 5 * 60 * 1000,
  });
